import React from "react"
import PWMarkdown from '../../common/PWMarkdown';

const Paragraph = (props) => {
    const { data } = props;
    return (
        <div className="super-ho-de-flexible-para">
            <PWMarkdown data={data} />
        </div>
    )
}

export default Paragraph;